import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import apiHelperService from '@/services'
import client_config from '@/assets/json/client_config.json'
import { useAuthStore } from '@/stores/auth'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { allowedAdministrativeRegionsForQuestionnaire, enableQuestionnaires } = client_config
  const {
    withException = '',
    administrativeRegionId = '',
    sponsoredUN = ''
  } = router.currentRoute.value.query

  formStore.extraMap = {
    ...formStore.extraMap,
    serviceTransactionId,
    withException: withException == 'true',
    administrativeRegionId,
    showQuestionnaireQuestionThree: true,
    showQuestionnaires:
      allowedAdministrativeRegionsForQuestionnaire.includes(parseInt(administrativeRegionId)) &&
      enableQuestionnaires
  }

  if (sponsoredUN) {
    let res = await apiHelperService.get(`/api/individual/${sponsoredUN}/sponsored`)
    if (res) {
      setDefaultVal(res)
    }
  }
}
const setDefaultVal = (res) => {
  const formStore = useFormStore()
  const {
    resiDepartmentCode = '',
    resiYear = '',
    resiServiceCode = '',
    resiSequenceNumber = '',
    resiVisaDepartmentCode = '',
    resiVisaYear = '',
    resiVisaSequenceNumber = '',
    resiVisaServiceCode = ''
  } = res
  let obj = {
    departemntCode: resiDepartmentCode || resiVisaDepartmentCode,
    fileYear: resiYear || resiVisaYear,
    serviceCode: resiServiceCode || resiVisaServiceCode,
    fileNumber: resiSequenceNumber || resiVisaSequenceNumber
  }
  formStore.draft.request = {
    ...formStore.draft.request,
    ...res,
    ...obj
  }
}
const initInfo = async () => {
  const authStore = useAuthStore()
  if (authStore.user.applicationId == 2) {
    return
  }
  const formStore = useFormStore()
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    const {
      defaultImmigrationDepartmentId,
      unifiedNumber,
      personFileTypeId,
      identityNumber,
      englishFullName,
      arabicFullName,
      nationalityId,
      fileNumber
    } = res
    formStore.draft.request = {
      ...formStore.draft.request,
      sponsorDepartmentId: defaultImmigrationDepartmentId,
      sponsorNumber: unifiedNumber,
      sponsorTypeId: personFileTypeId,
      sponsorIdentityNumber: identityNumber,
      sponsorEnglishName: englishFullName,
      sponsorArabicName: arabicFullName,
      sponsorNationalityId: nationalityId,
      sponsorFileNumber: fileNumber
    }
  }
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use206Preload error: ', error)
  }
}
